/**
 * Stats Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initStats() {
    const blocks = document.querySelectorAll(".stats");

    blocks.forEach((block) => {
      initCounterAnimation(block);
      console.log("[BLOCK] stats block initialized");
    });
  }

  // Initialize counter animation
  function initCounterAnimation(block) {
    const statValues = block.querySelectorAll(".stat_number");

    statValues.forEach((statValue) => {
      const finalValue = parseInt(statValue.dataset.finalValue || "0", 10);
      if (statValue.hasAttribute("data-animated") || isNaN(finalValue)) {
        return;
      }

      const parentContent = statValue.closest(".content");

      const triggerAnimation = () => {
        if (statValue.hasAttribute("data-animated")) {
          return;
        }
        statValue.setAttribute("data-animated", "true");
        animateCounter(statValue, finalValue);
      };

      if (parentContent) {
        if (parentContent.classList.contains("gsap-animated")) {
          triggerAnimation();
        } else {
          const mutationObserver = new MutationObserver(() => {
            if (parentContent.classList.contains("gsap-animated")) {
              mutationObserver.disconnect();
              triggerAnimation();
            }
          });
          mutationObserver.observe(parentContent, {
            attributes: true,
            attributeFilter: ["class"],
          });
        }
      } else {
        const intersectionObserver = new IntersectionObserver(
          (entries, observerInstance) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                observerInstance.unobserve(entry.target);
                triggerAnimation();
              }
            });
          },
          { threshold: 0.5 }
        );
        intersectionObserver.observe(statValue);
      }
    });
  }

  // Animate counter from 0 to target value
  function animateCounter(element, targetValue) {
    const duration = 2000; // 2 seconds
    const startTime = performance.now();
    const prefix = element.dataset.prefix || "";
    const suffix = element.dataset.suffix || "";

    function updateCounter(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.floor(easeOutQuart * targetValue);

      // Format the number with original prefix/suffix
      const displayValue = prefix + currentValue.toString() + suffix;

      element.textContent = displayValue;

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    }

    requestAnimationFrame(updateCounter);
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStats);
  } else {
    initStats();
  }
})();
